import src from "IMAGE";
export default { src, width: 544, height: 553, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAQklEQVR42oWPSQ4AIAgD68kl/v+9dgwnE2ROhE4CVTPLbDMCZq8mmQi963pARBK2Em6GmQk3K4XyBI98n4yaM6t5ADccBEl7NR+fAAAAAElFTkSuQmCC"};
